import { Reveal, Eyebrow } from "./Reveal";

export default function Impact() {
  return (
    <section id="impact" data-testid="impact-section" className="bg-parchment py-24 lg:py-36 border-y border-sand">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <Reveal>
            <Eyebrow tone="brand">04 — Impact</Eyebrow>
            <h2 className="mt-6 font-serif font-semibold text-4xl md:text-5xl leading-[1.05] tracking-tight text-pine max-w-2xl">
              Rooted in the village, run with the village.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-sage md:text-right md:max-w-xs">
              Employment, training & fair prices — kept inside the community
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <Reveal className="lg:col-span-8">
            <div
              data-testid="impact-card-shed"
              className="group relative overflow-hidden rounded-3xl h-[380px] lg:h-[560px]"
            >
              <img
                src="https://images.unsplash.com/photo-1784889822256-59a61641b986?auto=format&fit=crop&w=1400&q=80"
                alt="Cattle grazing at dusk near the Adveshta shed"
                className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-ink/55" />
              <div className="absolute inset-x-0 bottom-0 p-8 md:p-10">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
                  Our own cattle shed — Khushalpura, Vyara
                </p>
                <h3 className="mt-4 font-serif text-3xl md:text-4xl text-cream max-w-lg leading-tight">
                  100+ cattle, raised the clean & hygienic way
                </h3>
                <p className="mt-3 text-cream/70 text-sm md:text-base max-w-xl leading-relaxed">
                  A working demonstration shed where practices are shown to neighbouring villages —
                  so they can adopt and cultivate their own clean husbandry.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-4">
            <div
              data-testid="impact-card-fair-trade"
              className="group h-full rounded-3xl bg-pine text-cream p-8 md:p-10 flex flex-col justify-between hover:bg-royal transition-colors duration-500"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-gold">
                Fair-Trade Partnerships
              </p>
              <div className="mt-16 md:mt-24">
                <h3 className="font-serif text-2xl md:text-3xl leading-tight">
                  Fair compensation, straight to the farmer
                </h3>
                <p className="mt-4 text-cream/65 text-sm leading-relaxed">
                  Transparent, mutually beneficial relationships with village dairy farmers —
                  better returns for their produce, stable demand for their milk.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="lg:col-span-4">
            <div
              data-testid="impact-card-training"
              className="group h-full rounded-3xl bg-cream border border-sand p-8 md:p-10 flex flex-col justify-between hover:border-gold transition-colors duration-500"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">
                Learning at the Shed
              </p>
              <div className="mt-16 md:mt-24">
                <h3 className="font-serif text-2xl md:text-3xl leading-tight text-pine">
                  Skills that lift every litre
                </h3>
                <p className="mt-4 text-sage text-sm leading-relaxed">
                  Education and hands-on assistance in breeding, disease prevention and clean
                  milking — helping villagers optimise operations and maximise profits.
                </p>
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-8">
            <div
              data-testid="impact-card-regenerative"
              className="group grid md:grid-cols-2 overflow-hidden rounded-3xl bg-cream border border-sand h-full"
            >
              <div className="p-8 md:p-10 flex flex-col justify-center order-2 md:order-1">
                <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-brand">
                  Water, Soil & the Circular Farm
                </p>
                <h3 className="mt-4 font-serif text-2xl md:text-3xl leading-tight text-pine">
                  Regeneration, practised daily
                </h3>
                <p className="mt-4 text-sage text-sm leading-relaxed">
                  Regenerative farming techniques, efficient water management and proper food
                  management — keeping the village farm productive for the next generation.
                </p>
              </div>
              <div className="relative min-h-[240px] order-1 md:order-2 overflow-hidden">
                <img
                  src="https://images.unsplash.com/photo-1624354865892-6f3521416f89?auto=format&fit=crop&w=1100&q=80"
                  alt="Farmer working with cattle in the village"
                  className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
